_ = require("underscore")

module.exports = ($scope, $uibModalInstance, workflow, outcomeSchema) ->
  $scope.workflow = workflow
  $scope.outcomes = _.clone(workflow.outcomes || {})
  $scope.outcomeSchema = outcomeSchema
  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"

  $scope.save = ->
    $uibModalInstance.close $scope.outcomes
